import { Inject, Injectable } from '@angular/core';
import { AUTOMATION_NAMESPACE_INJECTION_TOKEN$ } from '@galaxy/automata/shared';
import { Observable } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { SalesOpportunitiesService } from '@vendasta/sales-opportunities';

@Injectable({ providedIn: 'root' })
export class OpportunityTagsService {
  tags$: Observable<string[]> = this.namespace$.pipe(
    switchMap((namespace) => this.salesOpportunityService.getTags(namespace, null)),
    map((tags) => tags.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  constructor(
    private salesOpportunityService: SalesOpportunitiesService,
    @Inject(AUTOMATION_NAMESPACE_INJECTION_TOKEN$) public readonly namespace$: Observable<string>,
  ) {}
}
